import { LucideSearch } from "lucide-react";
import { Input } from "../shadcn/Input";
import { useId, type ComponentProps } from "react";
import { cn } from "@/shared/utils/cn";

interface ListSearchProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  id?: string;
  className?: string;
  inputProps?: Omit<ComponentProps<"input">, "value" | "onChange" | "id" | "className" | "type" | "placeholder">;
}

export function ListSearch({ placeholder, value, onChange, label, id, className, inputProps }: ListSearchProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className={cn("relative min-w-0", className)}>
      <label htmlFor={inputId} className="sr-only">{label ?? placeholder}</label>
      <LucideSearch aria-hidden="true" className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
      <Input
        {...inputProps}
        type="search"
        id={inputId}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-12 pl-12 pr-4"
      />
    </div>
  );
}
